import { render, staticRenderFns } from "./SelectMultiplePermissions.vue?vue&type=template&id=ff6f4b26&"
import script from "./SelectMultiplePermissions.vue?vue&type=script&lang=ts&"
export * from "./SelectMultiplePermissions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports